import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { WriteButton, WriteIconButton } from '../../ui';

interface Props {
  label: string;
  description?: string;
  value: unknown[];
  onChange: (v: unknown[]) => void;
}

const ArrayField: React.FC<Props> = ({ label, description, value, onChange }) => {
  const items = Array.isArray(value) ? value : [];
  const isObjectArray = items.length > 0 && typeof items[0] === 'object' && items[0] !== null;

  const addItem = () => {
    if (isObjectArray || items.length === 0) {
      onChange([...items, '']);
    } else {
      onChange([...items, '']);
    }
  };

  const removeItem = (idx: number) => onChange(items.filter((_, i) => i !== idx));

  const updateItem = (idx: number, val: unknown) => {
    const next = [...items];
    next[idx] = val;
    onChange(next);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <Box>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#141417', fontFamily: 'Manrope, sans-serif' }}>{label}</Typography>
          {description && <Typography sx={{ fontSize: 11, color: '#6F6F6F' }}>{description}</Typography>}
        </Box>
        <WriteButton size="small" startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={addItem}
          sx={{ textTransform: 'none', fontSize: 12, color: '#0078B3' }}>
          Add
        </WriteButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        {items.map((item, idx) => (
          <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <Typography sx={{ fontSize: 12, color: '#A1A1A1', pt: 1, minWidth: 20 }}>{idx + 1}.</Typography>
            {typeof item === 'object' ? (
              <TextField
                fullWidth size="small" multiline minRows={2}
                value={JSON.stringify(item, null, 2)}
                onChange={(e) => { try { updateItem(idx, JSON.parse(e.target.value)); } catch { /* typing */ } }}
                InputProps={{ sx: { fontSize: 12, fontFamily: 'monospace', borderRadius: '6px' } }}
              />
            ) : (
              <TextField
                fullWidth size="small"
                value={String(item)}
                onChange={(e) => updateItem(idx, e.target.value)}
                InputProps={{ sx: { fontSize: 13, borderRadius: '6px' } }}
              />
            )}
            <WriteIconButton size="small" onClick={() => removeItem(idx)} sx={{ color: '#E53935', mt: 0.5 }}>
              <DeleteOutlineIcon sx={{ fontSize: 16 }} />
            </WriteIconButton>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ArrayField;
